import {Injectable} from '@angular/core';
import {Amplify} from '@aws-amplify/core';
import {cognitoCredentialsProvider, cognitoUserPoolsTokenProvider,} from '@aws-amplify/auth/cognito';
import {environment} from '../../environments/environment';
import {logUtishaDebug} from '../util/log';

@Injectable({
  providedIn: 'root'
})
export class AwsInitializer {

  configureAmplify(): void {
    const {userPoolId, webClientId, identityPoolId, oauthDomain} = environment.cognito;
    const amplifyConfig = {
      Auth: {
        Cognito: {
          identityPoolId,
          userPoolId,
          userPoolClientId: webClientId,
          authenticationFlowType: 'USER_SRP_AUTH',
          loginWith: {
            oauth: {
              providers: ['Google', 'Microsoft'],
              domain: oauthDomain,
              scopes: ['email', 'openid', 'profile'],
              redirectSignIn: [`${location.origin}/token`],
              redirectSignOut: [location.origin],
              responseType: 'code',
            },
            email: true
          },
        }
      }
    };
    logUtishaDebug(JSON.stringify(amplifyConfig, null, 6));
    // @ts-ignore
    cognitoUserPoolsTokenProvider.setAuthConfig(amplifyConfig.Auth);
    // @ts-ignore
    Amplify.configure(amplifyConfig, {
      Auth: {
        tokenProvider: cognitoUserPoolsTokenProvider,
        credentialsProvider: cognitoCredentialsProvider,
      },
    });
  }
}
